import { Pipe, PipeTransform } from '@angular/core';
import { MileageRateType } from './car-detail';

@Pipe({
  standalone: false,
  name: 'mileageType'
})
export class MileageTypePipe implements PipeTransform {
  transform(value: MileageRateType, args?: any): string {
    switch (value) {
      case MileageRateType.Unknown:
        return 'car.common.mileage.mileageRateType.unknown';
      case MileageRateType.Daily:
        return 'car.common.mileage.mileageRateType.day';
      case MileageRateType.Weekly:
        return 'car.common.mileage.mileageRateType.week';
      case MileageRateType.Monthly:
        return 'car.common.mileage.mileageRateType.month';
      default:
        return '';
    }
  }
}
